<mat-toolbar class="subtitulo">Movimentações Materiais</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <mat-horizontal-stepper #stepper style="background: transparent; padding: 10px">

        <!------------------ MOVIMENTAÇÃO ------------------------>
        <mat-step [stepControl]="formDadosMovimentacao">
            <form #formDadosMovimentacao="ngForm">
                <ng-template matStepLabel>MOVIMENTAÇÃO</ng-template>
                <dados-movimentacoes-materiais
                [movimentacoes]=movimentacoesMateriais
                ></dados-movimentacoes-materiais>
                <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                    fxFlexFill>
                    <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </form>
        </mat-step>

       
        <!-- ------------------ ITENS ------------------------ -->
        <mat-step style="padding-bottom: 20px" [stepControl]="formFaturas">
            <form #formFaturas="ngForm">
                <ng-template matStepLabel>ITENS</ng-template>
            </form>
            <itens-movimentacoes-materiais
                [listaItensMovimentacoesMateriais]=movimentacoesMateriais.itensMovimentacoesMateriais
            ></itens-movimentacoes-materiais>
            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                fxFlexFill>
                <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>


 <!-- BOTOES -->
 <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
 fxFlexFill>
 <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" [disabled]=formDadosMovimentacao.invalid
         mat-raised-button name="botaoConfirmar" fxFlex="20%" color="primary" (click)="cadastrar()">
         Cadastrar
 </button>

 <button *ngIf="isAtualizar && mostrarBotaoAtualizar" [disabled]=formDadosMovimentacao.invalid
         mat-raised-button name="botaoConfirmar" fxFlex="20%" color="primary" (click)="atualizar()">
         Atualizar
 </button>

 <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
         Limpar
 </button>
 <button mat-raised-button fxFlex="20%" (click)="cancelar()">
         Cancelar
 </button>

</div>